module.exports = __webpack_public_path__ + "static/source-sans-pro-v11-latin-700-f04441cfc122bf84e1cf24058fddba87.woff2";